import React, { Component } from 'react'
import Fab from '@material-ui/core/Fab';
import { connect } from 'react-redux';
import * as activityActions from '../../../../store/actions/activity';
import history from '../../../../history';

const mapStateToProps = (state) => {
    return {
        submitting: state.activityForm.submitting,
        isEditing: state.activityForm.id
    }
};

const mapDispatchToProps = (dispatch) => ({
    submitFormStarted: () => 
        dispatch(activityActions.submitCreateActivityFormStarted()),
    submitEditStarted: () =>
        dispatch(activityActions.submitEditActivityFormStarted()),
    resetForm: () => 
        dispatch(activityActions.resetActivityForm())
    }
);

class FormSubmitPanelContainer extends Component {
    cancelForm = () => {
        this.props.resetForm();
        history.push('/masterdata/viewallactivities');
    }
    submitForm = () => {
        if (this.props.isEditing) {
            this.props.submitEditStarted();
        } else {
            this.props.submitFormStarted();
        }
    }

    render() {
        return (
            <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: 100}}>
                <Fab variant="extended" className="form-submit-panel form-cancel" onClick={this.cancelForm}>Cancel</Fab>
                <Fab disabled={this.props.submitting} variant="extended" className="form-submit-panel form-submit" onClick={this.submitForm}>Submit</Fab>
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FormSubmitPanelContainer);